import { useState } from "react";
import { FaCopy, FaRegCopy } from "react-icons/fa";
import { BorderlessButton } from "./BorderlessButton";

export function CopyButton({ text, noborder }) {
    const [active, setActive] = useState(false);
    const Button = noborder ? BorderlessButton : "button";
    return (
        <Button
            type="button"
            title="Copy to clipboard"
            onClick={() => {
                setActive(true);
                navigator.clipboard
                    .writeText(text)
                    .then(() => setTimeout(() => setActive(false), 150));
            }}
        >
            {active ? <FaCopy fill="#3690b4" /> : <FaRegCopy />}
        </Button>
    );
}
